import {
  ContextMenu,
  ContextMenuCheckboxItem,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuLabel,
  ContextMenuRadioGroup,
  ContextMenuRadioItem,
  ContextMenuSeparator,
  ContextMenuShortcut,
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger,
  ContextMenuTrigger,
} from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function ContextMenuDemo() {
  return (
    <Section
      id="context-menu"
      title="ContextMenu"
      description="Right-click menu. Positioned at the cursor. Right-click the surface below."
    >
      <VariantBlock label="Right-click target">
        <ContextMenu>
          <ContextMenuTrigger className="flex h-32 w-80 cursor-context-menu items-center justify-center rounded-md border border-dashed border-border bg-card text-sm text-muted-foreground">
            Right-click anywhere inside
          </ContextMenuTrigger>
          <ContextMenuContent className="w-56">
            <ContextMenuLabel>Node actions</ContextMenuLabel>
            <ContextMenuItem inset>
              Open
              <ContextMenuShortcut>⌘O</ContextMenuShortcut>
            </ContextMenuItem>
            <ContextMenuItem inset>
              Duplicate
              <ContextMenuShortcut>⌘D</ContextMenuShortcut>
            </ContextMenuItem>
            <ContextMenuSub>
              <ContextMenuSubTrigger inset>Move to…</ContextMenuSubTrigger>
              <ContextMenuSubContent>
                <ContextMenuItem>Inbox</ContextMenuItem>
                <ContextMenuItem>Archive</ContextMenuItem>
              </ContextMenuSubContent>
            </ContextMenuSub>
            <ContextMenuSeparator />
            <ContextMenuCheckboxItem checked>
              Show bookmarks
            </ContextMenuCheckboxItem>
            <ContextMenuCheckboxItem>Show full path</ContextMenuCheckboxItem>
            <ContextMenuSeparator />
            <ContextMenuRadioGroup value="grid">
              <ContextMenuLabel inset>View</ContextMenuLabel>
              <ContextMenuRadioItem value="grid">Grid</ContextMenuRadioItem>
              <ContextMenuRadioItem value="list">List</ContextMenuRadioItem>
            </ContextMenuRadioGroup>
            <ContextMenuSeparator />
            <ContextMenuItem inset variant="destructive">
              Delete
              <ContextMenuShortcut>⌘⌫</ContextMenuShortcut>
            </ContextMenuItem>
          </ContextMenuContent>
        </ContextMenu>
      </VariantBlock>
    </Section>
  );
}
